import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import VerifyingIcon from '../posa/VerifyingIcon';
import RedirectWalletOverlayStyled from './RedirectWalletOverlayStyled';

const RedirectWalletOverlay = ({image}) => {
  return (
    <RedirectWalletOverlayStyled className="overlay">
      <div className="overlay-wrapper">
        <div className="overlay-content">
          <div className="overlay-content-wrapper">
            <div className="overlay-content-block">
              <h1>
                <Message code="epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.message" />
              </h1>
              <p>
                <span>
                  <Message code="epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.redirectMessage" />
                </span>
              </p>
              <p className="overlay-content-block__redirecting-now">
                <VerifyingIcon />
                <span>
                  <Message code="epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.redirecting" />
                </span>
              </p>
            </div>
            <div className="overlay-content-block">
              <img alt="Gift Card" src={image} />
            </div>
          </div>
        </div>
      </div>
    </RedirectWalletOverlayStyled>
  );
};

RedirectWalletOverlay.propTypes = {
  image: PropTypes.string,
};

export default RedirectWalletOverlay;
